import React, { FC } from 'react';
import classnames from 'classnames';

import { useRWD } from 'hooks';
import { useGetHomeHtmlBlock } from 'api';
import { Container } from 'components/controls';

import styles from 'theme/components/wise/WiseFooter/WiseFooter.module.scss';

const WiseFooter: FC = () => {
  const { isMobile } = useRWD();

  const { data: footerData } = useGetHomeHtmlBlock('HOME_FOOTER', 'FOOTER');

  const renderContent = () => {
    const contentMobile = footerData?.items.find(
      (item) => item.section_field_symbol === 'CONTENT_MOBILE'
    );
    const contentDesktop = footerData?.items.find((item) => item.section_field_symbol === 'CONTENT');

    if (isMobile && contentMobile) {
      return <div dangerouslySetInnerHTML={{ __html: contentMobile?.html_code || '' }} />;
    }

    if (contentDesktop) {
      return <div dangerouslySetInnerHTML={{ __html: contentDesktop?.html_code || '' }} />;
    }

    return null;
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-wise-WiseFooter'
      )}
      itemScope
      itemType="http://schema.org/Organization">
      <meta itemProp="url" content={window.location.href} />
      <Container style={{ padding: 0, maxWidth: 'none' }} fullWidth>
        <div className={styles.contentWrapper}>{renderContent()}</div>
      </Container>
    </div>
  );
};

export default WiseFooter;
